import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof console !== "undefined") {
      console.error(this.props.label || "Render error", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          className="ls-error-boundary-fallback"
          style={{
            padding: "12px 14px",
            margin: "8px 0",
            borderRadius: 8,
            border: "1px dashed var(--grey-400, #9aa3ad)",
            background: "var(--grey-50, #f7f8f9)",
            color: "var(--grey-600, #5b6570)",
            fontSize: 14,
          }}
        >
          {this.props.message || "This step couldn't be rendered"}
        </div>
      );
    }
    return this.props.children;
  }
}
